import React from "react";
import EmptyPage from "../../components/EmptyPage";

const Reports = () => {
  return (
    <EmptyPage
      title="Generated Reports"
      description="Access and download automatically generated reports for your deals, projects, valuations, and portfolio summaries."
      icon="📋"
    />
  );
};

export default Reports;
